import { forEach } from 'lodash'
import { BillOfLadingData } from '../apis/billOfLading.api'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    billsOfLading: BillOfLadingData[]
  ): TableHorizontalData<BillOfLadingData>[] {
    forEach(
      billsOfLading,
      (billOfLading: TableHorizontalData<BillOfLadingData>) => {
        billOfLading.actions = ['generate']
      }
    )
    return billsOfLading
  }
}
